import { memo } from "react"
import styled from "styled-components"

const ConstrolSafe = styled.div`
  display: flex;
  padding: 0px;
  justify-content: center;
  align-items: center;
`

const IconGradient = () => {
  return (
    <ConstrolSafe>
      <svg width="26" height="25" viewBox="0 0 26 25" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 13V21H9V13H11Z" fill="#486284" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19 13V21H17V13H19Z" fill="#486284" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M11 5V9H9V5H11Z" fill="#486284" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19 5V11H17V5H19Z" fill="#486284" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M7 9H13V11H7V9Z" fill="#486284" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M15 13H21V15H15V13Z" fill="#486284" />
        <g clip-path="url(#clip0_12591_18319)">
          <path
            d="M6.33398 0.333008L5.91398 1.24967L5.00065 1.66634L5.91398 2.08634L6.33398 2.99967L6.75065 2.08634L7.66732 1.66634L6.75065 1.24967M3.00065 1.33301L2.16732 3.16634L0.333984 3.99967L2.16732 4.83301L3.00065 6.66634L3.83398 4.83301L5.66732 3.99967L3.83398 3.16634M6.33398 4.99967L5.91398 5.91301L5.00065 6.33301L5.91398 6.74967L6.33398 7.66634L6.75065 6.74967L7.66732 6.33301L6.75065 5.91301"
            fill="#486284"
          />
        </g>
        <defs>
          <clipPath id="clip0_12591_18319">
            <rect width="8" height="8" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </ConstrolSafe>
  )
}

export default memo(IconGradient)
